module.exports = {
  back: 'Back',
};
